<template>
  <v-card style="cursor: auto" class="pa-2" hover outlined>
    <v-form ref="formPost" v-model="valid">
      <v-textarea :placeholder="$t('placeholder')" v-model="post" auto-grow rows="3" counter="700" :rules="postRules" outlined/>
      <div class="d-flex justify-end mt-n2">
        <p class="mb-0 mt-2 mr-3">{{ $t('postingOn') }}</p>
        <v-select :label="$t('label')" class="mt-n1 mb-n6" style="max-width: 25%;"
                  item-text="name" item-value="id" :items="channels" v-model="channel" dense outlined/>
        <v-btn :disabled="!valid" class="button-post ml-2" @click="addPost">{{ $t('btnPublish') }}</v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/club';
import { mapMutations } from 'vuex';

export default {
  name: "QuickPostBox",
  data() {
    return {
      valid: false,
      post: '',
      channels: [],
      channel: this.$store.state.currentClubChannel.id,
      postRules: [
        p => !!p || this.$t('errors.empty'),
        p => (p && p.length <= 700) || this.$t('errors.maxChars'),
      ]
    };
  },
  watch: {
    '$store.state.currentClubChannel': function () {
      this.updateChannel();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    updateChannel() {
      this.channel = this.$store.state.currentClubChannel.id;
    },
    init() {
      this.channels = [{ id: -1, name: 'GENERAL' }];
      this.$store.state.clubChannelsContributedByMe.forEach((channelContribution) => {
        this.channels.push(channelContribution.clubChannel);
      });
      this.channels.push.apply(this.channels, this.$store.state.clubPublicChannels);
    },
    ...mapMutations(['setClubPosts']),
    addPost() {
      if (this.valid) {
        let post = {
          clubMember: {id: this.$store.state.clubMember.id},
          post: this.post,
          date: new Date(),
        };
        if(this.channel !== -1)
          post.clubChannel = { id: this.channel };

        Repository.createClubPost(post).then((response) => {
          if (response.status < 400) {
            alert(this.$t('alert'));
            Repository.getAllClubPostsByChannel(this.$store.state.clubMember.club.id, this.$store.state.currentClubChannel.id).then((secondResponse) => {
              if (secondResponse.status < 400) {
                this.setClubPosts(secondResponse.data);
                this.post = '';
                this.$refs.formPost.reset();
              }
            });
          }
        });
      }
    },
  }
}
</script>

<i18n>
{
  "en": {
    "placeholder": "Write your message to the community...",
    "postingOn": "Posting on",
    "label": "Channel",
    "errors": {
      "empty": "Post could not be empty",
      "maxChars": "Max 700 characters"
    },
    "alert": "Post created successfully!",
    "btnPublish": "Publish Now"
  },
  "es": {
    "placeholder": "Escribe tu mensaje a la comunidad...",
    "postingOn": "Publicando en",
    "label": "Canal",
    "errors": {
      "empty": "Publicación no puede ser vacía",
      "maxChars": "Máximo 700 caracteres"
    },
    "alert": "¡Publicación creada satisfactoriamente!",
    "btnPublish": "Publicar Ahora"
  }
}
</i18n>

<style scoped>
  .button-post {
    background-color: #111111 !important;
    color: #ffffff !important;
  }

  .button-post:hover {
    background-color: #111111 !important;
    color: #ffffff !important;
    border: none !important;
  }
</style>
